var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureMain4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.916 50.513v-8.3h-6.94a1.51 1.51 0 0 1-1.5-1.5v-9.591h-2.038a1.4 1.4 0 0 1-1.225-.919 1.825 1.825 0 0 1 0-1.8l3.47-6.056A15.437 15.437 0 0 1 31.061 8.6a15.028 15.028 0 0 1 10.921 4.525 14.694 14.694 0 0 1 4.593 10.853 14.065 14.065 0 0 1-3.1 8.913 21.064 21.064 0 0 1-8.063 6.192v11.43zm6.4-18.779h1.5l.068-1.769a5.543 5.543 0 0 0 2.279-.816 8.058 8.058 0 0 0 1.531-1.293l1.565.748.741-1.225-1.293-1.021a8.141 8.141 0 0 0 .408-2.449 7.511 7.511 0 0 0-.408-2.381L38 20.507l-.748-1.225-1.565.748a5.549 5.549 0 0 0-1.565-1.293 6.549 6.549 0 0 0-2.245-.748l-.068-1.837h-1.5l-.068 1.837a6.613 6.613 0 0 0-2.313.748 5.549 5.549 0 0 0-1.565 1.293l-1.563-.748-.68 1.225 1.293 1.021a6.55 6.55 0 0 0-.476 2.381 7.092 7.092 0 0 0 .476 2.449l-1.293 1.021.68 1.221 1.565-.748a7.667 7.667 0 0 0 1.565 1.293 5.828 5.828 0 0 0 2.313.816zm.748-3.334a4.209 4.209 0 0 1-3.13-1.327 4.4 4.4 0 1 1 6.226-6.226 4.315 4.315 0 0 1 0 6.226 4.243 4.243 0 0 1-3.099 1.327z",
    transform: "translate(3.025 2.4)",
    style: {
      fill: "#fff"
    },
    "data-name": "\\uADF8\\uB8F9 163568"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureMain4);
export default __webpack_public_path__ + "static/media/feature-main-4.02a9fbc18f921ee6b79c9c01b2ceacfc.svg";
export { ForwardRef as ReactComponent };